import { Component } from '@theme/component';

/**
 * Featured Products filter tabs — client-side show/hide of product cards by
 * their data-category attribute, matched against the clicked tab's
 * data-filter value (both handleized so "Installation Shop" -> "installation-shop").
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement[]} [tabButtons]
 *
 * @extends {Component<Refs>}
 */
export class FeaturedProductsFilter extends Component {
  connectedCallback() {
    super.connectedCallback();

    for (const button of this.refs.tabButtons ?? []) {
      button.addEventListener('click', () => this.#filter(button));
    }
  }

  #filter(activeButton) {
    for (const button of this.refs.tabButtons ?? []) {
      button.classList.toggle('is-active', button === activeButton);
    }

    const filter = activeButton.dataset.filter;
    const cards = this.querySelectorAll('.featured-products__card');

    for (const card of cards) {
      const matches = filter === 'all' || card.dataset.category === filter;
      card.classList.toggle('is-hidden', !matches);
    }
  }
}

customElements.define('featured-products-filter', FeaturedProductsFilter);
